var map = {
	"./LateSerif-Black.woff2": 4630,
	"./LateSerif-Bold.woff2": 4594,
	"./LateSerif-Italic.woff2": 5589,
	"./LateSerif-Medium.woff2": 1091,
	"./LateSerif-Regular.woff2": 5491,
	"./LateSerif.var.woff2": 6765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3807;